import { message } from "antd";
import dayjs from "dayjs";
import { VehicleLoadingLogTable } from "features/log/components/table/loading-Item";
import { LodingFilterFormValuesPaginated} from "features/log/components/Top-bar/type";
import { VehicleLoadingLogTopBar } from "features/log/components/Top-bar/vehicleloading-top-bar";
import { useApproveReject } from "features/log/use-cases/create-weighbride";
import { useGetLogList } from "features/log/use-cases/get-getSuppliers";
import { usePaginationParams } from "hooks";
import { omit } from "lodash";
import {useState } from "react";
import { formatDate } from "utils/date";
export const LogVechileLoadingView = () => {
  const getInitialFilterValues: any = {
    date: [undefined, undefined],
    DriverName: undefined,
    SupplierName: undefined,
    VNumber: undefined,
  };
  const [userEditData, setUserEditData] = useState<any>(undefined);
  const [showAppUserModal, setShowAppUserModal] = useState(false);
  const { params, updateParams, resetPage } =
    usePaginationParams<LodingFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...getInitialFilterValues,
    });
  const preparePayload = (params1: LodingFilterFormValuesPaginated) => {
    const createdAtFrom = params1.date?.[0];
    const createdAtTo = params1.date?.[1];

    return {
      ...omit(params1, ['date']),
      EntryTypeId:1,
      created_at_from: createdAtFrom
        ? formatDate({
          date: dayjs(createdAtFrom).startOf('day'),
          format: 'dbDate',
        })
        : undefined,
      created_at_to: createdAtTo
        ? formatDate({
          date: dayjs(createdAtTo).endOf('day'),
          format: 'dbDate',
        })
        : undefined,
    };
  };
  const { mutate } = useApproveReject();
  const onApproveReject = (log: any, isApproved: number) => {
    const payload = {
      EntryId: log?.entryId,
      Type: log?.entryType,
      IsApproved: isApproved==1?1:2 ,
    };

    mutate(payload, {
      onError: () => {
        message.error("Something went wrong, please try again.");
      },
    });

  };
  const getvehcListQueryResponse: any = useGetLogList(preparePayload(params as any), {
    retry: false,
  });
  const handleFiltersChange = (values: any) => {
    updateParams(values);
    resetPage();
  };

  return (
    <>
      <VehicleLoadingLogTopBar
        getInitialFilterValues={getInitialFilterValues as any}
        handleFilter={handleFiltersChange}
        userEditData={userEditData}
        showAppUserModal={showAppUserModal}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getvehcListQueryResponse.refetch}
      />
      <VehicleLoadingLogTable
        isvehicleListLoading={
          getvehcListQueryResponse.isLoading &&
          getvehcListQueryResponse.isFetching
        }
        vehicleList={getvehcListQueryResponse?.data?.res?.items}
        itemsCount={getvehcListQueryResponse.data?.rc?.totalRecords || 0}
        tableParams={params as any}
        updateParams={updateParams}
        setUserEditData={setUserEditData}
        setShowAppUserModal={setShowAppUserModal}
        onApproveReject={onApproveReject}
        

      />
    </>


  );
};
